export default import.meta.ROLLDOWN_FILE_URL_YqBHFSRDozNW5VpX$B1Gaw